import {stage} from "../../../config/stage.ts";

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        dashboardId: string;
    };
};

const config: ConfigShape = {
    prod: {
        dashboardId: 'user-activity-dashboard-1744943372721',
    },
    test: {
        dashboardId: 'XXXXXXXXXXXXXXXXXXXXX',
    },
    dev: {
        dashboardId: 'user-activity-dashboard-1744943388676',
    },
    ide: {
        dashboardId: 'user-activity-dashboard-1744943388676',
    },
};

export default config[stage];
